/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './symptom-attribute-preference.reducer';

export const SymptomAttributePreferenceDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const symptomAttributePreferenceEntity = useAppSelector(state => state.symptomAttributePreference.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="symptomAttributePreferenceDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.symptomAttributePreference.detail.title">SymptomAttributePreference</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.symptomAttributePreference.id">Id</Translate>
            </span>
          </dt>
          <dd>{symptomAttributePreferenceEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.symptomAttributePreference.active">Active</Translate>
            </span>
          </dt>
          <dd>{symptomAttributePreferenceEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.symptomAttributePreference.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{symptomAttributePreferenceEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.symptomAttributePreference.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{symptomAttributePreferenceEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.symptomAttributePreference.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{symptomAttributePreferenceEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.symptomAttributePreference.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{symptomAttributePreferenceEntity.timestampEntry}</dd>
          <dt>
            <span id="symptomOrder">
              <Translate contentKey="tinyMedicRestApp.symptomAttributePreference.symptomOrder">Symptom Order</Translate>
            </span>
          </dt>
          <dd>{symptomAttributePreferenceEntity.symptomOrder}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.symptomAttributePreference.symptom">Symptom</Translate>
          </dt>
          <dd>{symptomAttributePreferenceEntity.symptom ? symptomAttributePreferenceEntity.symptom.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.symptomAttributePreference.attribute">Attribute</Translate>
          </dt>
          <dd>{symptomAttributePreferenceEntity.attribute ? symptomAttributePreferenceEntity.attribute.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/symptom-attribute-preference" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/symptom-attribute-preference/${symptomAttributePreferenceEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default SymptomAttributePreferenceDetail;
